'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

require('../styles/ProbeLogo.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProbeLogo = function (_BcReactComponent) {
  _inherits(ProbeLogo, _BcReactComponent);

  function ProbeLogo() {
    _classCallCheck(this, ProbeLogo);

    return _possibleConstructorReturn(this, (ProbeLogo.__proto__ || Object.getPrototypeOf(ProbeLogo)).apply(this, arguments));
  }

  _createClass(ProbeLogo, [{
    key: 'getLogoUrl',
    value: function getLogoUrl() {
      var imageName = 'account_linking_image';
      return this.props.baseUrl + '/images/' + this.props.siteId + '/' + imageName + '.png';
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = (0, _classnames2.default)('cp-probe-logo', {
        'logo-small': this.props.small,
        'logo-circled': this.props.circled
      }, this.props.className);

      return _react2.default.createElement('img', { src: this.getLogoUrl(), className: classes, alt: this.props.alt });
    }
  }]);

  return ProbeLogo;
}(_baseBcReactComponent2.default);

ProbeLogo.propTypes = {
  siteId: _react.PropTypes.string.isRequired,
  small: _react.PropTypes.bool,
  circled: _react.PropTypes.bool,
  baseUrl: _react.PropTypes.string,
  alt: _react.PropTypes.string,
  className: _react.PropTypes.string
};

ProbeLogo.defaultProps = {
  baseUrl: '',
  small: false,
  circled: false,
  alt: '' // Default to blank, assume it's decorative
};

exports.default = ProbeLogo;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-probe-logo/lib/components/ProbeLogo.component.js
// module id = 1503
// module chunks = 1